import { Button, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import AppStoreIcon from "../../../../../Assets/Images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917 1.svg";
import GooglPlayIcon from "../../../../../Assets/Images/GetItOnGooglePlay_Badge_Web_color_English 1.svg";
import AppStoreButtons from "./StoreButtons";

const CreditsMobile = (props) => {
  return (
    <div className="profile-wrapper">
      <div className="form-wrapper">
        <main className="form-content">
          <TextField
            autoComplete="off" // Disable autofill
            fullWidth
            id="available"
            name="available"
            label={"Available credits"}
            placeholder={""}
            variant="outlined"
            value={props.ProfileInfo.userCredit.balance}
            disabled
            margin="normal"
            sx={{
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "transparent", // Change border color when focused
                },
              backgroundColor: "#F3EEE6",
              borderRadius: "4px 4px 0 0",
              width: "95%",
              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
            }}
          />
          <TextField
            autoComplete="off" // Disable autofill
            fullWidth
            id="used"
            name="used"
            label={"Used credits"}
            placeholder={""}
            variant="outlined"
            value={props.ProfileInfo.userCredit.creditSpent}
            disabled
            margin="normal"
            sx={{
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "transparent", // Change border color when focused
                },
              backgroundColor: "#F3EEE6",
              borderRadius: "4px 4px 0 0",
              width: "95%",
              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
            }}
          />
          <Link to="/Home">
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: "#F8FAE5",
                "&:hover": {
                  backgroundColor: "#F8FAE5",
                },
                height: "36px",
                fontSize: "14px",
                display: "flex",
                width: "100%",
                color: "#292D32",
                boxShadow: "none",
                marginTop: "16px",
                gridGap: "8px",
                textTransform: "none", // Prevent text from being all caps,
              }}
            >
              Cancel
            </Button>
          </Link>
        </main>
        <div className="credits-info-mobile">
          <h3>Subscribe Now</h3>
          <h3>
            To unlock more credits and features, download the WeddinglyAi App
            from the Apple App Store or Google Play Store. Log in with your
            existing account credentials, select a subscription plan, and
            complete your purchase. Then sign out and back in on your web
            browser to access your benefits.
          </h3>
          <AppStoreButtons />
        </div>
      </div>
    </div>
  );
};

export default CreditsMobile;
